<template src="./selectoptions.html"></template>

<script>
  import { labelForMaterialTypeInCatalog } from '../../../../helpers/quoteMaterialTypeLabel'
  import SubNavigationBar from '../../../common/SubNavigationBar.vue'
  import { toTitleCase, titleCaseCatalogItem } from '../../../../helpers/titleCase'

  export default {
    components: {
      'app-sub-navigation-bar': SubNavigationBar
    },
    props: {
      title: {
        type: String,
        default: 'Options'
      },
      options: {
        type: Array
      },
      calculation: {
        type: Object
      },
      type: {
        type: String
      }
    },
    computed: {
      computedOptions: function () {
        if (this.filtered !== null) {
          return this.filtered
        }
        // Show full list until user picks a type or searches (was always [] — fittings/fixings looked empty).
        return this.payload || []
      },
      loading () {
        return !this.options || this.options.length === 0
      },
      /** Plural label for "Filter Fittings" / "Filter Fixings" in template */
      filterTypePlural () {
        if (this.type === 'Fitting') return 'Fittings'
        if (this.type === 'Fixing') return 'Fixings'
        return this.type || ''
      },
      typeSelectItems () {
        const getterKey = 'material/getType' + this.type
        const catalog = this.$store.getters[getterKey] || []
        const opts = (this.payload && this.payload.length) ? this.payload : (this.options || [])
        const ids = [...new Set(
          opts.map((m) => (m.type != null && m.type !== '' ? m.type : null)).filter((t) => t != null && t !== '')
        )]
        const allTypes = this.$store.getters['material/getTypes'] || []
        let items = ids.map((id) => {
          const sample = opts.find((m) => String(m.type) === String(id))
          return {
            id: Number(id) || id,
            name: labelForMaterialTypeInCatalog(catalog, id, sample, allTypes)
          }
        })
        items.sort((a, b) => String(a.name || '').localeCompare(String(b.name || '')))
        if (items.length === 0 && opts.length > 0) {
          items = [{ id: '__all__', name: 'All in this task' }]
        }
        return items
      }
    },
    data: function () {
      return {
        payload: [],
        search: null,
        filtered: null
      }
    },
    watch: {
      options: {
        immediate: true,
        deep: true,
        handler (val) {
          this.payload = JSON.parse(JSON.stringify(val || []))
          this.filtered = null
        }
      }
    },
    methods: {
      typesMatch (a, b) {
        if (a == null || b === '' || b == null) return false
        return String(a) === String(b)
      },
      filterByDescription: function (text) {
        if (text === '' || text == null) {
          this.filtered = null
          return
        }

        this.filtered = this.payload.filter((item) => {
          return item.description.toLowerCase().indexOf(text.toLowerCase()) !== -1
        })
      },
      filterByType: function (type) {
        if (type === '' || type == null || type === '__all__') {
          this.filtered = null
          return
        }

        this.filtered = this.payload.filter((item) => {
          return this.typesMatch(item.type, type)
        })
      },
      filterBySize: function (size) {
        if (size.id === '') {
          this.filtered = null
          return
        }

        let sizeObject = this.$store.getters['material/getSize'].filter((item) => {
          return size.id === item.id
        })

        if (this.filtered !== null) {
          this.filtered = this.options.filter((item) => {
            return (item.size >= sizeObject[0].prev + 1 && item.size <= sizeObject[0].id)
          })
          return
        }

        this.filtered = this.options.filter((item) => {
          return (item.size >= sizeObject[0].prev + 1 && item.size <= sizeObject[0].id)
        })
      },
      getTypeName: function (id) {
        return this.$store.getters['material/getType' + this.type].filter((type) => {
          return type.id === id
        })[0].name
      },
      displayCatalogName: function (value) {
        return toTitleCase(value)
      },
      save: function () {
        const payload = (this.payload || []).map((item) => titleCaseCatalogItem(item))
        this.$emit('payload', { payload: payload, calculation: this.calculation })
        this.$emit('close')
      },
      setOptionQty: function (option, qty) {
        const amount = Number(qty)
        this.$set(option, 'qty', Number.isFinite(amount) ? Math.round(amount) : 0)
      },
    }
  }
</script>

<style scoped>
  .modal-body {
    padding-top: 0px;
  }

  thead {
    font-weight: bold;
  }

  td {
    border-bottom: black;
    margin-top: 4px;
  }

  input {
    max-width: 100px;
  }
</style>
